import { Clock, Info, MapPin, Smile } from "lucide-react";
import type { BeachPracticalInformation } from "@/lib/data/beach-destination-details";

function IconBadge({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#fff4e5] text-[#f5a623]">
            {children}
        </div>
    );
}

function SectionRow({
    icon,
    title,
    children,
}: {
    icon: React.ReactNode;
    title: string;
    children: React.ReactNode;
}) {
    return (
        <div className="flex gap-4">
            <IconBadge>{icon}</IconBadge>
            <div className="flex-1 min-w-0 pt-1">
                <h3 className="font-exo-bold text-bleu-marine text-base mb-1.5">{title}</h3>
                <div className="text-sm text-slate-600 leading-relaxed">{children}</div>
            </div>
        </div>
    );
}

export default function BeachPracticalInfo({ information }: { information: BeachPracticalInformation }) {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 md:p-8">
            <h2 className="text-2xl font-exo-bold text-bleu-marine mb-8">Informations Pratiques</h2>

            <div className="space-y-7">
                <SectionRow icon={<MapPin className="h-5 w-5" />} title="Localisation">
                    <p>{information.location}</p>
                </SectionRow>

                <SectionRow icon={<Clock className="h-5 w-5" />} title="Meilleure période">
                    <p>{information.bestPeriod}</p>
                </SectionRow>

                <div className="flex gap-4">
                    <IconBadge>
                        <Info className="h-5 w-5" />
                    </IconBadge>
                    <div className="flex-1 min-w-0 pt-1">
                        <h3 className="font-exo-bold text-bleu-marine text-base mb-3">Infos utiles</h3>
                        <ul className="space-y-2.5 text-sm text-slate-600 leading-relaxed">
                            {information.usefulInfo.map((item) => (
                                <li key={item.label}>
                                    <span className="font-semibold text-slate-700">{item.label} :</span>{" "}
                                    {item.value}
                                </li>
                            ))}
                            {information.emergencyNumbers && (
                                <li>
                                    <span className="font-semibold text-slate-700">Numéros utiles :</span>{" "}
                                    {information.emergencyNumbers}
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                <SectionRow icon={<Smile className="h-5 w-5" />} title="Activités">
                    <p>{information.activitiesSummary}</p>
                </SectionRow>
            </div>
        </div>
    );
}
